import _ from 'lodash';
import spacetime from 'spacetime';

export const yearList = [
  spacetime.now().subtract(3, 'year').format('year'),
  spacetime.now().subtract(2, 'year').format('year'),
  spacetime.now().subtract(1, 'year').format('year'),
  spacetime.now().format('year'),
  spacetime.now().add(1, 'year').format('year'),
  spacetime.now().add(2, 'year').format('year'), // Add more future years for rollforward
];

export const QUARTERS = _.flatten(
  _.map(yearList, (year) => [
    `Q1 ${year}`,
    `Q2 ${year}`,
    `Q3 ${year}`,
    `Q4 ${year}`,
  ])
);

export const YEARS = _.map(yearList, (year) => ({
  label: `FY ${year}`,
  value: year,
}));
